import React from 'react'
import './SignUp.css'
import RadioCards from '../RadioCards/RadioCard'
import { Typography } from '@material-ui/core'

export default function SignUpFirstCard() {
  return (
    <>
      <Typography
        variant="h2"
        align="center"
        style={{
          padding: '25px 0 10px'
        }}>
        What are you representing?
      </Typography>
      <Typography variant="body1">
        select only the one that apply on you
      </Typography>
      <RadioCards />
    </>
  )
}
